import { OrderGetResponseType } from "@sellar-io/api-v2/types";
import { useSupplierRelationshipList } from "../../../hooks/api/v2/supplierRelationship/useSupplierRelationshipList";
import { OrderContent } from "./OrderContent";

export const SupplierOrderContent = ({
  order,
}: {
  order: OrderGetResponseType;
}) => {
  const supplierRelationshipListQuery = useSupplierRelationshipList({
    limit: 1,
    query: [
      {
        type: "buyerId",
        modifier: "EQUALS",
        value: order.RetailerId,
      },
    ],
  });
  const supplierRelationship =
    supplierRelationshipListQuery.data?.pages[0]?.[0];
  const connection = supplierRelationship;

  return (
    <OrderContent
      order={order}
      connection={connection}
      isLoading={supplierRelationshipListQuery.isLoading}
    />
  );
};
